<template>
  <a-card>
    <span slot="title">MASTER KERJA PRAKTEK</span>
    <div v-if="!isMobile" slot="extra" class="d-flex flex-row">
      <a-input-search v-model="search" placeholder="Pencarian ... " class="m-right" />
      <a-select
        placeholder="Status"
        v-model="status"
        class="w-full"
        allowClear
        style="margin-right: 15px"
      >
        <a-select-option key="Aktif">Aktif</a-select-option>
        <a-select-option key="Non Aktif">Non Aktif</a-select-option>
      </a-select>
      <a-button type="primary" @click="handleNew" icon="plus">Buat Baru</a-button>
    </div>
    <div v-else class="d-flex flex-row m-bottom">
      <a-input-search v-model="search" placeholder="Pencarian ... " class="m-right" />
      <a-button type="primary" icon="plus">{{isMobile ? '' : 'Karyawan Baru'}}</a-button>
    </div>

    <a-list
      :grid="{ gutter: 16, xs: 1, lg: 2, xxl: 3 }"
      :dataSource="searching"
      :pagination="pagination"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card hoverable @click="handleProfile(item)">
          <div :class="isMobile ? 'd-flex flex-column' : 'd-flex flex-row'">
            <div class="d-flex flex-column align-item-center">
              <div class="photo-wrapper m-bottom">
                <img class="photo-profile" alt="foto-profile" :src="$serviceUrl + item.foto + '?' + pictureTime" />
              </div>
              <!-- <a-button-group>
                <a-button @click="handleProfile(item)">Profile</a-button>
                <a-button @click="handleEdit(item)" type="danger" icon="edit"></a-button>
              </a-button-group>-->
              <div class="width-full">
                <a-tag class="magang-card d-flex flex-column align-item-center" color="cyan">
                  <div style="font-size: xx-small;">KARTU MAGANG</div>
                  <div style="font-size: x-large;text-align: center;">{{item.no_visitor}}</div>
                </a-tag>
              </div>
              <!-- <div class="magang-card d-flex flex-column align-item-center">
                <div>KARTU MAGANG</div>
                <div>G-0MX</div>
              </div> -->
            </div>
            <a-divider v-if="isMobile"></a-divider>
            <ul class="list-wrapper m-left">
              <li>
                <div style="height:50px">
                  <h4 class="m-remove">Nama Siswa / Mahasiswa</h4>
                  <span class="m-text-medium">{{item.nama_lengkap?item.nama_lengkap:'-'}}</span>
                </div>
              </li>
              <li>
                <h4 class="m-remove">Jenis Identitas</h4>
                <span class="m-text-medium">{{item.jenis_identitas?item.jenis_identitas:'-'}}</span>
              </li>
              <li>
                <h4 class="m-remove">Nomor Identitas</h4>
                <span class="m-text-medium">{{item.nomor_identitas?item.nomor_identitas:'-'}}</span>
              </li>
              <li>
                <h4 class="m-remove">Nama Sekolah / Universitas</h4>
                <span class="m-text-medium">{{item.nama_sekolah?item.nama_sekolah:'-'}}</span>
              </li>
              <li>
                <h4 class="text-title m-remove">Jenjang</h4>
                <span class="m-text-medium">{{item.kelas?item.kelas:'-'}}</span>
              </li>
              <li>
                <h4 class="text-title m-remove">jurusan</h4>
                <span class="m-text-medium">{{item.jurusan?item.jurusan:'-'}}</span>
              </li>
            </ul>
          </div>
        </a-card>
      </a-list-item>
    </a-list>
  </a-card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "list.karyawan",
  data() {
    return {
      datalist: [],
      basedList: [],
      search: "",
      pagination: {
        onChange: page => {
          console.log(page);
        },
        showTotal:total => {return 'Total '+total+' Items data';},
        pageSize: 6,
        size: "small",
      },
      pictureTime : Date(),
      status: undefined,
    };
  },
  computed: {
    ...mapGetters(["getAuth","getStatusKaryawan"]),
    searching() {
      let data = this.datalist;

      if (this.search) {
        data = data.filter(
          item =>
            item.nama_lengkap && item.nama_lengkap.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.jenis_identitas && item.jenis_identitas.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.nomor_identitas && item.nomor_identitas.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.nama_sekolah && item.nama_sekolah.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.kelas && item.kelas.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.jurusan && item.jurusan.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if(this.status){
        data = data.filter(
        item =>
          item.status && item.status.toLowerCase()==this.status.toLowerCase()
        );
      }

      return data;
    },
  },
  created(){
    this.$store.dispatch("FETCH_STATUSKARYAWAN");
  },
  activated() {
    this.pictureTime = Date();
  },
  methods: {
    async fetching() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "internship",
        params: {
          "X-API-KEY": this.getAuth.apikey
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        }
      })
        .then(response => {
          this.datalist = response.data.data;
          this.basedList = response.data.data;
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    handleProfile(item) {
      this.$router.push({
        name: "hrd.siswa.profile",
        params: { id_siswa: item.id_siswa }
      });
    },
    handleEdit(item) {
      this.$router.push({
        name: "siswarubah",
        params: { tlc: item.tlc, nik: item.nik }
      });
    },
    handleNew() {
      this.$router.push({ name: "siswabaru" });
    },
  },
  mounted() {
    this.fetching();
  }
};
</script>

<style lang="less" scoped>
.magang-card{
  align-items: center;
  width: fit-content;
  padding: @padding/2;
  font-weight: bolder;
  line-height: 1.2rem;
}
</style>